module.exports = __webpack_public_path__ + "img/Welding-Training-01.3023663e.jpg";